import { render, staticRenderFns } from "./SaveToLibraryButton.vue?vue&type=template&id=27232ca7&scoped=true"
import script from "./SaveToLibraryButton.vue?vue&type=script&lang=js"
export * from "./SaveToLibraryButton.vue?vue&type=script&lang=js"
import style0 from "./SaveToLibraryButton.vue?vue&type=style&index=0&id=27232ca7&prod&lang=less"
import style1 from "./SaveToLibraryButton.vue?vue&type=style&index=1&id=27232ca7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27232ca7",
  null
  
)

export default component.exports